import React, { useState } from "react";
import Axios from "axios";
import { Redirect, withRouter } from "react-router";
import { LoginLayout } from "../../components/login/LoginLayout";
const SystemUpdates = props => {
  console.log(props.Login);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [wrongPassFlag, setwrongPassFlag] = useState(false);
  const [logging, setLogging] = useState(false);

  const [showNo, setShowNo] = useState(false);

  let showYes = false;

   








  return (
    <div>
      {!props.isLogin && (
        <LoginLayout  >

            {showNo && <h4>


                      نعتذر عن إيقاف النظام نظرا لإجراء بعض التعديلات على النظام
                      <br/>

                      The System will be available soon due to Services Updates.



                </h4>}
            

        </LoginLayout>
      )}
    </div>
  );
};

export default withRouter(SystemUpdates);



// WEBPACK FOOTER //
// ./src/pages/SystemMessages/SystemUpdates.js